export default __webpack_public_path__ + "static/media/userShortcuts.c422aa03.svg";